import type { MenuConfig } from '~typings/menu'

// import permisosCxP, { RESOURCE_CXP } from '@/auth/permissions/modules/cxp'
// import configuracion from './configuracion'
import transacciones from './transacciones'

// import informes from './informes'
export default [
    // {
    //     title: 'exportaciones.menu_title',
    //     fontIcon: 'ship',
    //     resource: 'Exportaciones',
    //     action: 'ver-exportaciones',
    //     children: [
    //         // {
    //         //     title: 'global.menu.configuracion',
    //         //     icon: 'SettingsIcon',
    //         //     action: permisosCxP.configuracion._perm,
    //         //     children: configuracion
    //         // },
    //         {
    //             title: 'global.menu.transacciones',
    //             fontIcon: 'exchange-alt',
    //             action: 'ver-exportaciones-transacciones',
    //             children: transacciones,
    //         },
    //         // {
    //         //     title: 'global.menu.informes',
    //         //     fontIcon: 'file-prescription',
    //         //     action: permisosCxP.informes._perm,
    //         //     children: informes
    //         // },
    //     ],
    // },
] as MenuConfig[]
